<template>
    <admin-layout>

        <template #toolbox>

        </template>

        <app-content-pane class="ml-3">
            <template #title>
                <div class="px-4 pt-3">
                    <h1>Merge Organization Utility</h1>
                </div>
                <hr class="mb-0">
            </template>

            <section>
                <div class="px-4 py-3 d-flex align-items-center border-bottom">
                    <div class="actions ml-auto">
                        <button type="button"
                                @click="submit()"
                                class="btn btn-danger">
                            Transfer Everything and Remove Old Organization
                        </button>
                    </div>
                </div>
            </section>

            <section>
                <div class="px-4 py-3">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="text-uppercase">Transfer From</div>
                            <h5 class="mb-3">
                                <strong>#{{ from.id }}</strong> <span class="text-muted">/</span> {{ from.name }}
                            </h5>
                            <div class="table-responsive" v-if="from.users.length">
                                <table class="table">
                                    <thead>
                                    <tr>
                                        <th colspan="3">Users:</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="user in from.users" :key="user.id">
                                        <td>{{ user.id }}</td>
                                        <td>{{ user.name }}</td>
                                        <td>{{ user.email }}</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="table-responsive" v-if="from.projects.length">
                                <table class="table">
                                    <thead>
                                    <tr>
                                        <th colspan="2">Projects:</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="project in from.projects" :key="project.id">
                                        <td>{{ project.id }}</td>
                                        <td>{{ project.name }}</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="text-uppercase">Transfer To</div>
                            <h5 class="mb-3">
                                <strong>#{{ to.id }}</strong> <span class="text-muted">/</span> {{ to.name }}
                            </h5>
                        </div>
                    </div>

                </div>
            </section>

        </app-content-pane>

    </admin-layout>
</template>

<script>
import AppContentPane from "@/Components/AppContentPane";
import AdminLayout from "@/Layouts/AdminLayout";
import Button from "@/Jetstream/Button";
export default {
    name: "MergeOrganization",
    components: {Button, AdminLayout, AppContentPane},
    props: ['from', 'to'],

    methods: {
        submit(){

            if( ! confirm(`Are you sure to merge "${this.from.name}" with "${this.to.name}"?\n\nTHIS PROCESS CAN'T BE UNDONE.`) );

            this.$inertia.post( this.route('utility.merge', {...this.global_url_params}), {
                from: this.from.id,
                to: this.to.id,
            }, {
                onSuccess: (res) => {
                    console.log({res});
                }
            });
        },
    }

}
</script>

<style scoped>

</style>
